import {isEmpty} from 'lodash';
import React, {useEffect, useState} from 'react';
import AdminCollegeListingService, {
  AdminChangedListingsResponse,
  AdminChurnedPartnersResponse,
  AdminCurrentPartnersResponse,
  AdminNonPartnersResponse,
} from 'src/services/AdminCollegeListingService';
import TextInput from 'src/components/inputs/text-input';
import Icon from 'shared/components/icon';
import ListingTable from './ListingTable';
import ListingTableSkeleton from './ListingTableSkeleton';
import styles from './styles.module.scss';

export default function AdminCollegeListings() {
  const [changedData, setChangedData] = useState<AdminChangedListingsResponse | null>(null);
  const [currentPartnersData, setCurrentPartnersData] =
    useState<AdminCurrentPartnersResponse | null>(null);
  const [churnedPartnersData, setChurnedPartnersData] =
    useState<AdminChurnedPartnersResponse | null>(null);
  const [nonPartnersData, setNonPartnersData] = useState<AdminNonPartnersResponse | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    AdminCollegeListingService.fetchChanged().then(setChangedData);
    AdminCollegeListingService.fetchCurrentPartners().then(setCurrentPartnersData);
    AdminCollegeListingService.fetchChurnedPartners().then(setChurnedPartnersData);
    AdminCollegeListingService.fetchNonPartners().then(setNonPartnersData);
  }, []);

  const partnersEditable =
    (currentPartnersData ?? changedData ?? nonPartnersData)?.partnersEditable ?? true;
  const lastUniId = (currentPartnersData ?? changedData)?.lastUniId;

  return (
    <>
      <div className={styles.searchBox}>
        <TextInput
          type="search"
          placeholder="Search colleges..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          size="medium"
        >
          <Icon iconType="search" className={styles.searchIcon} />
        </TextInput>
      </div>

      {changedData ? (
        !isEmpty(changedData.changedListings) && (
          <ListingTable
            title="Colleges with Outstanding Changes"
            listings={changedData.changedListings}
            lastUniId={changedData.lastUniId}
            partnersEditable={partnersEditable}
            searchQuery={searchQuery}
          />
        )
      ) : (
        <ListingTableSkeleton title="Colleges with Outstanding Changes" rows={3} />
      )}

      {currentPartnersData ? (
        !isEmpty(currentPartnersData.currentPartners) && (
          <ListingTable
            title="Partner Colleges — Current"
            listings={currentPartnersData.currentPartners}
            lastUniId={currentPartnersData.lastUniId}
            partnersEditable={partnersEditable}
            searchQuery={searchQuery}
          />
        )
      ) : (
        <ListingTableSkeleton title="Partner Colleges — Current" rows={8} />
      )}

      {churnedPartnersData ? (
        !isEmpty(churnedPartnersData.churnedPartners) && (
          <ListingTable
            title="Partner Colleges — Churned"
            listings={churnedPartnersData.churnedPartners}
            lastUniId={churnedPartnersData.lastUniId}
            partnersEditable={partnersEditable}
            searchQuery={searchQuery}
          />
        )
      ) : (
        <ListingTableSkeleton title="Partner Colleges — Churned" rows={4} />
      )}

      {nonPartnersData ? (
        !isEmpty(nonPartnersData.nonPartnerListings) && (
          <ListingTable
            title="Non-Partner Colleges"
            listings={nonPartnersData.nonPartnerListings}
            lastUniId={lastUniId}
            partnersEditable={partnersEditable}
            nonPartners
            searchQuery={searchQuery}
          />
        )
      ) : (
        <ListingTableSkeleton title="Non-Partner Colleges" rows={8} />
      )}
    </>
  );
}
